var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5120_239421)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H8.5H12H15.5H24V8.5V12V15.5V24H15.5H12H8.5H0V15.5V12V8.5V0ZM8.5 8.5C7.60433 9.39576 7.05 10.6332 7.05 12C7.05 13.3668 7.60433 14.6042 8.5 15.5C9.39576 16.3957 10.6332 16.95 12 16.95C13.3668 16.95 14.6042 16.3957 15.5 15.5C16.3957 14.6042 16.95 13.3668 16.95 12C16.95 10.6332 16.3957 9.39576 15.5 8.5C14.6042 7.60433 13.3668 7.05 12 7.05C10.6332 7.05 9.39576 7.60433 8.5 8.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12H7.05C7.05 13.3668 7.60433 14.6042 8.5 15.5V12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05 12H8.5V8.5C7.60433 9.39576 7.05 10.6332 7.05 12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L8.5 8.5V12H12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5H8.5L12 12V8.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5H12L12 7.05C10.6332 7.05 9.39576 7.60433 8.5 8.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5H15.5C14.6042 7.60433 13.3668 7.05 12 7.05L12 8.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.5H12V12L15.5 8.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.5L12 12H15.5V8.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12H16.95C16.95 10.6332 16.3957 9.39576 15.5 8.5V12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.95 12H15.5V15.5C16.3957 14.6042 16.95 13.3668 16.95 12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L15.5 15.5V12H12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5L12 12V15.5H15.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L8.5 15.5H12V12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.5L12 12H8.5V15.5Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.95L12 15.5H8.5C9.39576 16.3957 10.6332 16.95 12 16.95Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5L12 16.95C13.3668 16.95 14.6042 16.3957 15.5 15.5H12Z",
    fill: "#56DCB7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0H0M8.5 0H12M8.5 0V8.5M0 0V8.5M0 0L8.5 8.5M8.5 8.5H12M8.5 8.5L12 12M8.5 8.5V12M8.5 8.5C7.60433 9.39576 7.05 10.6332 7.05 12M8.5 8.5H0M8.5 8.5C9.39576 7.60433 10.6332 7.05 12 7.05M8.5 8.5C8.50012 8.49988 8.49988 8.50012 8.5 8.5ZM24 0H15.5M24 0V8.5M24 0L15.5 8.5M15.5 0H12M15.5 0V8.5M15.5 8.5H12M15.5 8.5L12 12M15.5 8.5V12M15.5 8.5C14.6042 7.60433 13.3668 7.05 12 7.05M15.5 8.5C16.3957 9.39576 16.95 10.6332 16.95 12M15.5 8.5C15.5001 8.50012 15.4999 8.49988 15.5 8.5ZM15.5 8.5H24M24 8.5V12M0 8.5V12M12 8.5V0M12 8.5V12M12 8.5L12 7.05M0 15.5V24M0 15.5V12M0 15.5H8.5M0 24H8.5M0 24L8.5 15.5M8.5 15.5L12 12M8.5 15.5V12M8.5 15.5H12M8.5 15.5C7.60433 14.6042 7.05 13.3668 7.05 12M8.5 15.5C9.39576 16.3957 10.6332 16.95 12 16.95M8.5 15.5C8.49988 15.4999 8.50012 15.5001 8.5 15.5ZM8.5 15.5V24M15.5 15.5L12 12M15.5 15.5V12M15.5 15.5H12M15.5 15.5C16.3957 14.6042 16.95 13.3668 16.95 12M15.5 15.5H24M15.5 15.5C14.6042 16.3957 13.3668 16.95 12 16.95M15.5 15.5C15.4999 15.5001 15.5001 15.4999 15.5 15.5ZM15.5 15.5V24M15.5 15.5L24 24M24 24V15.5M24 24H15.5M24 15.5V12M24 12H15.5M15.5 12H12M15.5 12H16.95M12 12V15.5M12 12H8.5M0 12H8.5M8.5 12H7.05M12 15.5V24M12 15.5L12 16.95M12 24H8.5M12 24H15.5",
    stroke: "#56DCB7",
    strokeOpacity: 0.24,
    strokeWidth: 0.125,
    strokeDasharray: "0.5 0.25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.0625,
    y: 2.0625,
    width: 15.875,
    height: 19.875,
    rx: 1.9375,
    stroke: "#56DCB7",
    strokeOpacity: 0.48,
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.0625,
    y: 4.0625,
    width: 19.875,
    height: 15.875,
    rx: 1.9375,
    stroke: "#56DCB7",
    strokeOpacity: 0.48,
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.0625,
    y: 3.0625,
    width: 17.875,
    height: 17.875,
    rx: 1.9375,
    stroke: "#56DCB7",
    strokeOpacity: 0.48,
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.9375,
    stroke: "#56DCB7",
    strokeOpacity: 0.48,
    strokeWidth: 0.125
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5120_239421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignTemplate);
export default __webpack_public_path__ + "static/media/design-template.82db14d384691590b3f424d3757541cc.svg";
export { ForwardRef as ReactComponent };